import i18next from 'i18next';
import { criarCurriculo } from './criarCurriculo';
import { cursos } from './cursos';
import { deficiencia } from './deficiencia';
import { diversidade } from './diversidade';
import { experiencias } from './experiencias';
import { formacoes } from './formacoes';
import { fotos } from './fotos';
import { visibleY } from './helpers';
import { idiomas } from './idiomas';
import { infoComplementar } from './infoComplementar';
import { informatica } from './informatica';
import { objetivo } from './objetivo';
import { privacidadeCurriculo } from './privacidade';
import { progressoCurriculo } from './progresso';
import { redeSocial } from './redeSocial';
import { sintese } from './sintese';
import { uploadArquivo, uploadLaudo } from './uploads';
import { visualizarCurriculo } from './visualizar';

let _formacaoLoad = false;
let _diversidadeLoad = false;
let _experienciaLoad = false;
let _cursosLoad = false;
let _idiomasLoad = false;
let _informaticaLoad = false;
let _complementarLoad = false;
let _objetivoLoad = false;

export function loadMetodosIniciais(dados, $panel) {
    body.find('#CurriculoTipo').val(dados.tipo.Tipo);
    body.find('#CurriculoPrivacidade').val(dados.privacidade.Tipo);

    window.global.loaderFull.hide();

    if (dados.tipo.Tipo === 0) {
        criarCurriculo();
        return;
    }
    body.find('#modal-tipoCurriculo').find('#texto-tipoCurriculo').html(i18next.t('inicialCurriculoAtual') + ' <b style="color:' + dados.tipo.Cor + '">' + dados.tipo.Nome + '</b>');

    body.find('#panel-config-curriculo').html([

        '<a href="javascript:void(0)" class="label label-primary btn-privacidade" data-toggle="tooltip" title="' + dados.privacidade.Descricao + '"><i class="fa ' + dados.privacidade.Icone + '"></i> ' + dados.privacidade.Nome + '</a>',
        '<button type="button" href="javascript:void(0)" class="btn btn-primary noborder nopadding pull-right outline btn-privacidade"><i class="fa fa-unlock-alt"></i> ' + i18next.t('inicialPrivacidade') + '</button>'
    ].join(''));
    body.find('#CurriculoColaborador').val(dados.colaborador);

    var sinteseTitulo = i18next.t('sinteseTitulo');
    var sinteseDescreva = i18next.t('sinteseDescreva');
    var sintedeInfo = i18next.t('sinteseDescrevaInfo');
    if (dados.tipo.Tipo === 1 || dados.tipo.Tipo === 2) {
        sinteseTitulo = i18next.t('sinteseCarta');
        sinteseDescreva = i18next.t('sinteseCartaDescreva');
        if (dados.tipo.Tipo === 1) {
            sintedeInfo = i18next.t('sinteseCartaInfo');
        } else {
            sintedeInfo = i18next.t('sinteseCartaInfoEstagio');
        }
    }
    body.find('#panel-sintese').html([
        '<div class="panel-heading">',
        '<h3 class="panel-title"><i class="fa fa-coffee"></i> ' + sinteseTitulo + '<span class="hide btn-add"><button type="button" href="javascript:void(0)" class="btn btn-primary noborder nopadding pull-right outline"><i class="fa fa-edit mr5"></i> ' + i18next.t('btnEditarCamelCase') + '</button></span> </h3>',
        '</div>',
        '<div class="panel-body padding30 pt10">',
        '<div id="sintese-contentform"></div>',
        '<div id="sintese-null" class="hide">',
        '<h4 class="text-center mb15"><b>' + sinteseDescreva + '</b></h4>',
        '<p class="text-muted text-center mb15">' + sintedeInfo + '</p>',
        '<button class="btn btn-outline-primary center-block btn-add"><i class="fa fa-plus mr5"></i> ' + i18next.t('btnAdicionar') + ' ' + sinteseTitulo + '</button>',
        '</div>',
        '<div style="margin-bottom: 8px">',
        '<p id="sintese-lista" style="display:none;"></p>',
        '<p id="sintese-lista-mostrar" style="display:inline;"></p>',
        '<button id="ver-mais-btn" class="btn btn-primary noborder nopadding outline" style="margin-left: 4px">  ' + i18next.t('verMais') + '</button>',
        '<button id="ver-menos-btn" class="btn btn-primary noborder nopadding hide outline" style="margin-left: 4px">  ' + i18next.t('verMenos') + '</button>',
        '</div>',
        '</div>',
        '<div class="panel-default-loader hide"></div>'
    ].join(''));

    carregarRedesSociaisSdk();
    visualizarCurriculo();
    privacidadeCurriculo();

    fotos();
    redeSocial();
    deficiencia(dados.semDeficiencia, dados.deficienciaTexto);
    sintese(dados.miniCurriculo);
    progressoCurriculo();

    var lazzyLoadMethods = function () {
        if (!_objetivoLoad) {
            var visivelObjetivo = visibleY(document.getElementById('panel-objetivo'));
            if (visivelObjetivo) {

                const dadosPretensaoSalarial = {
                    pretensaoSalarialID: dados.pretensaoSalarialID,
                    pretensaoSalarial: dados.pretensaoSalarial,
                    moedaSigla: dados.moedaSigla,
                    pretensaoSalarialMin: dados.pretensaoSalarialMin,
                    pretensaoSalarialMax: dados.pretensaoSalarialMax,
                    separadorSalario: dados.separadorSalario,
                    salarioConvertidoEnum: dados.salarioConvertidoEnum,
                };

                objetivo(dadosPretensaoSalarial);
                _objetivoLoad = true;
            }
        }

        if (!_formacaoLoad) {
            var visivelFormacao = visibleY(document.getElementById('panel-formacao'));
            if (visivelFormacao) {
                formacoes();
                _formacaoLoad = true;
            }
        }
        if (!_diversidadeLoad) {
            const visivelDiversidade = visibleY(document.getElementById('panel-diversidade'));
            if (visivelDiversidade) {
                diversidade();
                _diversidadeLoad = true;
            }
        }
        if (!_experienciaLoad) {
            var visivelExperiencia = visibleY(document.getElementById('panel-experiencia'));
            if (visivelExperiencia) {
                experiencias(dados.semExperiencia);
                _experienciaLoad = true;
            }
        }
        if (!_cursosLoad) {
            var visivelCurso = visibleY(document.getElementById('panel-curso'));
            if (visivelCurso) {
                cursos();
                _cursosLoad = true;
            }
        }
        if (!_idiomasLoad) {
            var visivelIdioma = visibleY(document.getElementById('panel-idioma'));
            if (visivelIdioma) {
                idiomas();
                _idiomasLoad = true;
            }
        }
        if (!_complementarLoad) {
            var visivelComplementar = visibleY(document.getElementById('panel-complementar'));
            if (visivelComplementar) {
                infoComplementar(dados.filhos, dados.filhosID);
                _complementarLoad = true;
            }
        }
        if (!_informaticaLoad) {
            var visivelInformatica = visibleY(document.getElementById('panel-informatica'));
            if (visivelInformatica) {
                informatica();
                _informaticaLoad = true;
            }
        }

    };
    $(window).scroll(function () {
        lazzyLoadMethods();
    });
    lazzyLoadMethods();

    uploadLaudo.init();
    uploadArquivo.init();

}

